let doc = window.document;
import scr from "scrollreveal";
import Swiper from "./component/swiper.min.js";

if (doc.addEventListener) {
  doc.addEventListener("DOMContentLoaded", function() {
    console.log("DOM complete");

    //lets handle with vimeo modal
    const modalBtnArr = document.querySelectorAll("[data-modal]");
    const modalWindow = document.querySelector(".video-modal");
    const closeModal = document.querySelector(".modal-close");
    const vimeoLink = document.querySelector("#vimeo-src");
    const modalTitle = document.querySelector(".modal-vimeo__text h4");
    const modalText = document.querySelector(".modal-vimeo__text p");

    //close modal
    if (closeModal) {
      closeModal.addEventListener("click", () => {
        modalWindow.classList.remove("visible");
        vimeoLink.setAttribute("src", "");
      });
    }

    if (modalBtnArr.length) {
      for (let i = 0; i < modalBtnArr.length; i++) {
        modalBtnArr[i].addEventListener("click", e => {
          const target = e.target;
          const title = target.dataset.title;
          const link = target.dataset.link;
          const text = target.dataset.text;

          //open modal
          modalWindow.classList.add("visible");
          modalTitle.textContent = title;
          modalText.textContent = text;
          vimeoLink.setAttribute("src", link);
        });
      }
    }

    //SLIDR SWIPER
    const slider = new Swiper(".slider", {
      slidesPerView: 1,
      loop: false,
      pagination: ".slider__dots",
      spaceBetween: 0,
      speed: 1000,
      effect: "fade",
      autoplay: 4000
    });

    //handle contact form
    const captchaNumbers = document.querySelectorAll(".captcha span");
    const form = document.querySelector("#form");

    let captchaResult =
      +captchaNumbers[0].textContent + +captchaNumbers[1].textContent;

    form.addEventListener("submit", e => {
      e.preventDefault();
      const captchaTest = document.querySelector("#captcha").value;
      if (captchaResult != captchaTest) {
        alert("Your captcha is invalid");
      } else {
        //lets handle all sending data
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
          alert(xhr.responseText);
        }; // success case
        xhr.onerror = function() {
          alert(xhr.responseText);
        }; // failure case
        xhr.open("POST", "../lib/mailer/formHandler.php", true);
        xhr.send(new FormData(document.querySelector("#form")));
        return false;
      }
    });

    //console.log(captchaResult);

    //open mobile nav and staff
    const modalBtn = document.querySelector(".nav-btn");
    const navMenu = document.querySelector(".header__nav");
    modalBtn.addEventListener("click", () => {
      modalBtn.classList.toggle("active");
      navMenu.classList.toggle("visible");
      document.body.classList.toggle("opened-menu");
    });
    //scroll reveal stuff
    window.sr = scr();
    sr.reveal(
      ".hero__title",
      {
        distance: "-100px",
        duration: 1000,
        viewFactor: 0.2,
        scale: 1,
        origin: "right",
        viewOffset: { top: 0, right: 0, bottom: 0, left: 80 }
      },
      250
    );
    sr.reveal(".grid-item-wrapper", { duration: 600 }, 250);

    sr.reveal(
      "footer",
      {
        distance: "-100px",
        duration: 1000,
        viewFactor: 0.2,
        scale: 1,
        origin: "top",
        viewOffset: { top: 100, right: 0, bottom: 0, left: 0 }
      },
      250
    );
    //sr.reveal(".hero__image");
    sr.reveal(".product__item");
  });
} else {
  alert("Please, renew your web browser for better performance.");
}



// WEBPACK FOOTER //
// ./app/main.js